export default __webpack_public_path__ + "static/media/watchone.4d4ad033.jpg";